import { Link } from "react-router-dom";

export default function BrandWordmark({
  ariaLabel = "Return to Biology Trader homepage",
  testId = "brand-wordmark-link",
  onClick,
}) {
  return (
    <Link to="/" className="inline-flex items-center gap-1" aria-label={ariaLabel} data-testid={testId} onClick={onClick}>
      <span className="font-display text-lg md:text-xl leading-none tracking-tight text-ink" style={{ fontWeight: 800 }}>
        The Biology Trader
      </span>
      <span className="text-[10px] align-top text-[#245943] ml-0.5 mt-[-4px]" aria-hidden="true">™</span>
    </Link>
  );
}
